import { GrantEvent } from '../../../types/events.types';
import { EditEventStepVariant } from '../event-form/event-form.types';

export const grantUsesTemplateSignatureWizard = (
  grant: Pick<GrantEvent, 'selectedTemplateId'>,
): boolean => Boolean(grant.selectedTemplateId);

export const grantEditPreviewStepFromPersistedGrant = (grant: GrantEvent): EditEventStepVariant =>
  (grantUsesTemplateSignatureWizard(grant) ? 6 : 4) as EditEventStepVariant;
